<div class="home-container">
  <!-- Video de fondo a pantalla completa -->
  <video 
    #videoPlayer
    class="background-video" 
    playsinline
    (ended)="onVideoEnded()">
    <source [src]="videoUrl" type="video/mp4">
    Tu navegador no soporta el elemento de video.
  </video>

  <!-- Overlay oscuro para mejor legibilidad -->
  <div class="video-overlay" [class.playing]="isPlaying && !isPaused"></div>

  <!-- Contenido principal -->
  <div class="content" [class.playing]="isPlaying">
    <div class="logo-container" [class.playing]="isPlaying">
      <img src="/images/logo-argo-v8.png" alt="Argo V8" class="main-logo" />
    </div>
    
    <div class="welcome-section" [class.playing]="isPlaying">
      <p class="subtitle" [class.hidden]="isPlaying">La nueva generación de aplicaciones ARGO</p>
      
      <div class="actions">
        <button 
          sca-button 
          variant="border" 
          (click)="onDiscoverTrailer()">
         Descubre el trailer
        </button>
        
        <button 
          sca-button 
          variant="primary" 
          (click)="onDiscoverArgoV8()">
          Descubre Argo V8
        </button>
      </div>
    </div>
  </div>

  <!-- Controles de video -->
  <div class="video-controls" *ngIf="isPlaying">
    <div class="controls-container">
      <!-- Play/Pause -->
      <button class="control-button" (click)="togglePlayPause()">
        <sca-icon [icon]="isPaused ? 'play_arrow' : 'pause'"></sca-icon>
      </button>

      <!-- Control de volumen -->
      <div class="volume-control">
        <button class="control-button" (click)="toggleMute()">
          <sca-icon [icon]="isMuted || volume === 0 ? 'volume_off' : volume < 50 ? 'volume_down' : 'volume_up'"></sca-icon>
        </button>
        <input 
          type="range" 
          min="0" 
          max="100" 
          [value]="volume" 
          (input)="onVolumeChange($event)"
          class="volume-slider"
        />
      </div>
    </div>
  </div>
</div>
